function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70px",
    height: "70px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.763
    },
    fill: "#4aa670",
    d: "M 25.5,-0.5 C 31.5,-0.5 37.5,-0.5 43.5,-0.5C 56.8333,3.5 65.5,12.1667 69.5,25.5C 69.5,31.5 69.5,37.5 69.5,43.5C 65.5,56.8333 56.8333,65.5 43.5,69.5C 37.5,69.5 31.5,69.5 25.5,69.5C 12.1667,65.5 3.5,56.8333 -0.5,43.5C -0.5,37.5 -0.5,31.5 -0.5,25.5C 3.5,12.1667 12.1667,3.5 25.5,-0.5 Z M 29.5,4.5 C 55.151,5.16172 66.3177,18.1617 63,43.5C 56.8057,58.3514 45.639,65.1848 29.5,64C 12.0165,59.1748 3.84986,47.6748 5,29.5C 8.68291,16.6514 16.8496,8.31807 29.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#4ba770",
    d: "M 28.5,7.5 C 53.5721,7.40648 64.0721,19.7398 60,44.5C 54.9539,55.2776 46.4539,60.9443 34.5,61.5C 17.5,60.5 8.5,51.5 7.5,34.5C 8.22353,20.4604 15.2235,11.4604 28.5,7.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/starFull.b878952cdeb3763a5a8d72a17ea74f93.svg";
export { ForwardRef as ReactComponent };